/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The type of notification:
 *   * END_OF_CHARGE
 *   * PAYMENT_REFUSED
 *   * NEW_INVOICE
 *   * INVOICE_PAID
 *   * SUBSCRIPTION_RENEWED
 *   * SUBSCRIPTION_EXPIRED
 *   * BOOKING_CONFIRMED
 *   * BOOKING_EXPIRED
 *   * LOW_BALANCE
 */
export enum NotificationType {
  END_OF_CHARGE = 'END_OF_CHARGE',
  PAYMENT_REFUSED = 'PAYMENT_REFUSED',
  NEW_INVOICE = 'NEW_INVOICE',
  INVOICE_PAID = 'INVOICE_PAID',
  SUBSCRIPTION_RENEWED = 'SUBSCRIPTION_RENEWED',
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  BOOKING_EXPIRED = 'BOOKING_EXPIRED',
  LOW_BALANCE = 'LOW_BALANCE'
}
